export default __webpack_public_path__ + "static/media/logo_flibco.c7acbb3e.svg";